module.exports = __webpack_public_path__ + "static/media/follicular-tab.32851fdc.svg";